import React from 'react';
import { Select } from '@chakra-ui/react';

export const StageSelect = ({ onChange, disabled, newStage }) => (
	<Select name="stage" {...{ onChange, disabled }}>
		<option value="1" selected={newStage === '1'}>
			Этап 1
		</option>
		<option value="2" selected={newStage === '2'}>
			Этап 2
		</option>
		))}
	</Select>
);
